import ComponentWithSocket from '../../../lib/component'
import { Component, Watch } from 'vue-property-decorator';

import * as Store from '../../../store';

import template from './verifications.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../../utils/ws';

@Component({
    mixins: [template]
})

export default class LiveAuction extends ComponentWithSocket {

    private data: { 
        verifications: any[],
        perPage: number,
        currentPage: number,
        verificationsCount: number,
        searchQuery: string,
        isSearching: boolean
    } = {
        verifications: [],
        perPage: 50,
        currentPage: 1,
        verificationsCount: 0,
        searchQuery: this.$attrs.s ? this.$attrs.s : "",
        isSearching: false
    };

    rejectReason: string = ''
    selectedVerification?: any

    @Watch('data.searchQuery')
    onSearchQueryChanged(val: string, oldVal: string) {
        if (!this.data.isSearching) {
            setTimeout(() => {
                this.data.isSearching = false;
                this.data.currentPage = 1;
                this.insertParam('s', this.data.searchQuery);
                
                this.reloadVerifications(1);
            }, 1000);
        }
        this.data.isSearching = true;
    }

    constructor() {

        super();

        this.wsListener.onGet('admin.verifications', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.verifications = data.verifications;
                this.data.verificationsCount = data.verificationsCount;
            }

        });

        this.wsListener.onPost('admin.verifications.review', (success: boolean, data: any) => {

            if (success) {
                this.wsListener.sendGet('admin.verifications')
            }
            else {
                Store.commitLoaderVisibility(this.$store, false);
                alert(data)
            }

        });

    }

    public reloadVerifications(
        page: any = this.data.currentPage
    ) {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet("admin.verifications", {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: page 
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.verifications', {
            searchQuery: this.data.searchQuery,
            perPage: this.data.perPage,
            currentPage: this.data.currentPage 
        });

    }

    acceptVerification(verification: any) {

        Store.commitLoaderVisibility(this.$store, true)

        this.wsListener.sendPost('admin.verifications.review', {
            verification: verification._id,
            accepted: true
        })

    }

    rejectVerification(verification: any) {

        this.selectedVerification = verification

        let ref: any = this.$refs['reason-modal']

        ref.show()

    }

    doRejectVerification() {

        Store.commitLoaderVisibility(this.$store, true)

        this.wsListener.sendPost('admin.verifications.review', {
            verification: this.selectedVerification._id,
            accepted: false,
            reason: this.rejectReason
        })

    }

    public insertParam(key: any, value: any) {
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
    
        // kvp looks like ['key1=value1', 'key2=value2', ...]
        var kvp = document.location.search.substr(1).split('&');
        let i=0;
    
        for(; i<kvp.length; i++){
            if (kvp[i].startsWith(key + '=')) {
                let pair = kvp[i].split('=');
                pair[1] = value;
                kvp[i] = pair.join('=');
                break;
            }
        }
    
        if(i >= kvp.length){
            kvp[kvp.length] = [key,value].join('=');
        }
    
        // can return this or...
        let params = kvp.join('&');
    
        // reload page with new params
        window.history.replaceState(null, '', '?' + params);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/users/verifications/index.ts